import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { LearningUnitJsonModel } from '../learning-unit/learning-unit.json.model';
import { ConsumerJsonModel } from '../consumer/consumer.json.model';
import { SubjectJsonModel } from '../subject/subject.json.model';
import { SchoolClassJsonModel } from '../core/global-enums/school-class/school-class.json.model';

export class ModuleJsonModel extends JsonApiModel {
  public static override readonly type = 'modules';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public preTitle!: string;

  @Field()
  public title!: string;

  @Field()
  public description!: string;

  @Field()
  public preview!: {
    id: string
    name: string
    mediaType: string
    media_url: string
  } | null;

  @Field()
  public content!: string[];

  @Field()
  public status!: string;

  @Field({ toOne: () => ConsumerJsonModel })
  public consumer!: ConsumerJsonModel;

  @Field({ toMany: () => SubjectJsonModel })
  public subjects!: SubjectJsonModel[];

  @Field({ toMany: () => SchoolClassJsonModel })
  public schoolClasses!: SchoolClassJsonModel[];

  @Field({ toMany: () => LearningUnitJsonModel })
  public learningUnits!: LearningUnitJsonModel[];
}
